import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import type { MenuProps } from "../utils/local-antd";
import React from "react";
import styled from "styled-components";

import { Images } from "../assets";
import i18n from "../i18n";
import { Spacing } from "../theme/Spacing";
import { TestIDs } from "../tests/types/testIds";
import { AtiraDropdown } from "./AtiraDropdown";
import { AtiraIcon } from "./AtiraIcon";
import { Button } from "./Button";
import { Flex } from "./Flex";
import { AtiraImage } from "./Image";
import { Text } from "./Text";
import { AppLangs } from "../model/shared/enum/AppLangs.enum";

const LanguageWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  gap: ${Spacing.s};
`;

const currentLanguage = i18n.language.toUpperCase();

export const LanguageSwitcher: React.FC = () => {
  const changeLanguage = (lang: AppLangs) => {
    // Keep the URL's `?lang=` in sync with the choice, the same param the
    // marketing site hands off with (see i18n.tsx) - so a reload, bookmark,
    // or share of this page carries the language the user picked here too.
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState(null, "", url);

    setTimeout(() => {
      i18n.changeLanguage(lang);
    }, 0);
  };

  const items: MenuProps["items"] = [
    {
      key: "g1",
      type: "group",
      children: [
        {
          key: "en",
          label: (
            <LanguageWrapper
              dataTestId={TestIDs.auth.languageSwitcher.option(AppLangs.EN)}
            >
              <AtiraImage src={Images.USAFlag} width={20} />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.EN),
        },
        {
          key: "ar",
          label: (
            <LanguageWrapper
              dataTestId={TestIDs.auth.languageSwitcher.option(AppLangs.AR)}
            >
              <AtiraImage src={Images.SaudiFlag} width={20} />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.AR),
        },
        {
          key: "tr",
          label: (
            <LanguageWrapper
              dataTestId={TestIDs.auth.languageSwitcher.option(AppLangs.TR)}
            >
              <AtiraImage src={Images.TurkishFlag} width={20} />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.TR),
        },
      ],
    },
  ];

  return (
    <AtiraDropdown
      items={items}
      placement="bottom"
      dataTestId={TestIDs.auth.languageSwitcher.trigger}
    >
      <Button padding="none" margin="none">
        <Flex alignItems="center" gap="s">
          <AtiraIcon icon={faGlobe} size="2x" color="sub" />
          <Text color="white">
            {currentLanguage.toLowerCase() === AppLangs.AR
              ? "ع"
              : currentLanguage}
          </Text>
        </Flex>
      </Button>
    </AtiraDropdown>
  );
};
